import { render } from "./BtnDropdown.vue?vue&type=template&id=0d0362c4&scoped=true&ts=true&lang=pug"
import script from "./BtnDropdown.vue?vue&type=script&lang=ts"
export * from "./BtnDropdown.vue?vue&type=script&lang=ts"

import "./BtnDropdown.vue?vue&type=style&index=0&id=0d0362c4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0362c4"]])

export default __exports__